import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddDepartment = () => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");

  const [formValues, setFormValues] = useState({
    department_id: "",
    department_name: "",
    contact_no: "",
    email_address: "",
  });

  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    if (
        formValues.contact_no.length < 8 ||
        formValues.contact_no.length > 15
      ) {
        setError(true);
        return;
      }
    if (isSaving) return; // Prevent multiple submissions

    try {
      
      setIsSaving(true);
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-department`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/department-list");
        }, 2000);
      }
    } catch (err) {
      // Reset only on failure
      // Check for 400 status error
      setLoading(false);
      setIsSaving(false);
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
      } else if (err.response && err.response.status === 409) {
        setSnackbarMessage(
          "This department ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
      }
      setOpenSnackbar(true);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department ID <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="name"
                  placeholder="Enter Department ID"
                  value={formValues.department_id}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        department_id: e.target.value,
                      });
                    }
                  }}
                  required
                />
              </div>
              <div className="mb-20">
                <label
                  htmlFor="department_name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="department_name"
                  placeholder="Enter Department Name"
                  value={formValues.department_name}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        department_name: value,
                      });
                    }
                  }}
                  required
                  // onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
                {/* {touched && !formValues.department_name && (
                      <small className="text-danger-600">
                        Department Name is required
                      </small>
                    )} */}
              </div>

              <div className="mb-20">
                <label
                  htmlFor="contact_no"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Contact No.<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="contact_no"
                  value={formValues.contact_no}
                  onChange={(e) => {
                    const regex = /^[0-9]*$/; // Only allows numeric input
                    const value = e.target.value;

                    if (
                      (regex.test(value) || value === "") &&
                      value.length <= 15
                    ) {
                      setFormValues({
                        ...formValues,
                        contact_no: value,
                      });
                    }
                  }}
                  onBlur={() => {
                    setIsMobileTouched(true); // Mark field as touched when focus is lost
                    if (
                      formValues.contact_no.length < 8 ||
                      formValues.contact_no.length > 15
                    ) {
                      setError(
                        "Contact number must be between 8 and 15 digits."
                      );
                    } else {
                      setError(""); // Clear error if valid
                    }
                  }}
                  placeholder="Enter your contact number"
                  maxLength={15} // Ensure no more than 15 characters
                  required
                />
                {/* {isMobileTouched && !formValues.contact_no && (
                      <small className="text-danger-600">
                        Contact number is required
                      </small>
                    )} */}

                {isMobileTouched && (
                  <>
                    {formValues.contact_no &&
                      (formValues.contact_no.length < 8 ||
                        formValues.contact_no.length > 15) && (
                        <small className="text-danger-600">
                          Contact number must be between 8 and 15 digits.
                        </small>
                      )}
                  </>
                )}
              </div>

              <div className="mb-20">
                <label
                  htmlFor="number"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Email<span className="text-danger-600">*</span>
                </label>
                <input
                  type="email"
                  className="form-control radius-8"
                  id="number"
                  required
                  placeholder="Enter Email"
                  value={formValues.email_address}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      email_address: e.target.value,
                    })
                  }
                />
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/department-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  disabled={isSaving || loading} // Ensure button is disabled
                >
                  {loading && "Save"}
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  {!loading && "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddDepartment;
